<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.debitamount}">
      Debit $<input :value="debitamount" name="debitamount" class="form-control input-numeric" @input="handleChange"> from account
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      debitamount: Number,
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.isNumber(this.debitamount) || this.debitamount < 0) {
          this.errors.debitamount = "Please enter a debit amount.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
